import type { StatementsCountryConfig } from '../StatementsConfig';

export const statements: StatementsCountryConfig = {
    enabled: true,
    createStatement: true,
    mode: 'flag',
};
